export function formatDepartureTime (departureDate: Date) {
    // User entered date is in the device tz, we want it in the departure airport tz.
    // Send the date values as entered by the user and let the server interpret it.

    let [hours, minutes] = ['12', '00']

    let year = String(departureDate.getFullYear())

    let month = String(departureDate.getMonth() + 1)
    if (month.length == 1) {
        month = '0' + month
    }

    let day = String(departureDate.getDate())
    if (day.length == 1) {
        day = '0' + day
    }

    return `${year}-${month}-${day}T${hours}:${minutes}:00Z`
}
